import axios from 'axios';
import { environment } from 'environments/environment';

export interface User {
    id?: string;
    role: string;
    email: string;
    password: string;
}

export const getAllUsersAsync: any = async () => {
    let res: any;
    const getAllUsers = async () => {
        await axios
            .get(`${environment.apiBaseUrl}users/all`, {
                headers: {
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                res = response.data;
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };

    await getAllUsers();
    return res;
};

export const addUserAsync = async (userRow: User) => {
    const response = await axios.post(`${environment.apiBaseUrl}users/add`, userRow, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${environment.authToken}`
        }
    });

    return true;
};

export const resetPasswordAsync = async (email: string) => {
    const response = await axios.post(
        `${environment.apiBaseUrl}users/resetpassword`,
        { email: email },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${environment.authToken}`
            }
        }
    );

    return true;
};

export const changePasswordAsync = async (email: string, password: string) => {
    const response = await axios.post(
        `${environment.apiBaseUrl}users/resetpassword`,
        { email: email, password: password },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${environment.authToken}`
            }
        }
    );

    return true;
};

export const deleteUserAsync = async (id: string, deletedBy: string) => {
    const response = await axios.post(
        `${environment.apiBaseUrl}users/deleteUser`,
        { id: id, deletedBy: deletedBy },
        {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${environment.authToken}`
            }
        }
    );

    return true;
};

export const updateUserAsync = async (userRow: User) => {
    const response = await axios.post(`${environment.apiBaseUrl}users/updateUser`, userRow, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${environment.authToken}`
        }
    });

    return true;
};

export default getAllUsersAsync;
